// src/store/actions/newsLetterAction.js
import { db } from "../../config/firebase";
import { collection, query, where, getDocs, addDoc } from "firebase/firestore";
import { toast } from "react-toastify";

const newsletterRef = collection(db, "newsletter");

export const subscribeToNewsletter = async (email, onComplete = () => {}) => {
    try {
        const q = query(newsletterRef, where("email", "==", email));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            toast.error("This email is already subscribed.");
            return { success: false };
        }

        await addDoc(newsletterRef, {
            email,
            subscribedAt: new Date(),
        });

        toast.success("Successfully subscribed!");

        return { success: true };
    } catch (error) {
        toast.error("Something went wrong!");
        return { success: false, message: error.message };
    } finally {
        onComplete();
    }
};
